import { render, staticRenderFns } from "./CoursePage.vue?vue&type=template&id=1e1d9fb6&scoped=true&lang=true&"
import script from "./CoursePage.vue?vue&type=script&lang=js&"
export * from "./CoursePage.vue?vue&type=script&lang=js&"
import style0 from "./CoursePage.vue?vue&type=style&index=0&id=1e1d9fb6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1d9fb6",
  null
  
)

export default component.exports